import {Injectable} from '@angular/core';
import {LogoutStrategy} from './logout-strategy';
import {LogoutConfirmService} from '../logout-confirm.service';
import {environment} from '../../../../../../environments/environment';
import {GlobalConstants} from 'src/app/shared/global-constants';
import {switchMap, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NativeLogoutStrategy implements LogoutStrategy {

  constructor(private readonly logoutConfirmService: LogoutConfirmService) {}

  execute(uuid: string): void {
    this.logoutConfirmService.deleteUserDetails(uuid).pipe(
      switchMap(() => this.logoutConfirmService.logout()),
      tap(() => {
        const logoutUrl = `${window.location.origin}/assets/logout.html`;
        localStorage.clear();
        localStorage.setItem(GlobalConstants.REDIRECT_URL, environment.redirectUrl);
        window.open(logoutUrl, '_self');
      })
    ).subscribe();
  }
}
